<template>
    <div>
        <h2 v-if="linked"><router-link :to="{name: 'about-me', params: {locale: $route.params.locale}}">{{ $t('side-bar.about-me') }}</router-link></h2>
        <router-link :to="{name: 'about-me'}"><v-img src="../assets/wiebke_winzer.jpg" class="framed"></v-img>
        <h3 class="pt-8 text-sm-right">Wiebke Winzer</h3>
        <p class="pt-1 text--secondary text-sm-right" style="font-size: 0.8em" v-html="$t('side-bar.details')">
        </p>
        </router-link>
        <v-row v-if="false">
            <v-col class="text-right">
                <v-btn to="/issue-2" class="mx-2" fab dark small color="primary">
                    <v-icon>mdi-home</v-icon>
                </v-btn>
                <v-btn to="/issue-2" class="mx-2" fab dark small color="secondary">
                    <v-icon>mdi-star</v-icon>
                </v-btn>
                <v-btn to="/issue-2" class="mx-2" fab dark small color="accent">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>

export default {
    name: 'SideBar',
    data() {
        return {
            linked: this.$route.name !== "about-me"
        }
    }
}
</script>

<style scoped>
.framed {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
a {
    color: black !important;
}
</style>